import * as actions from '../actions'

export interface BackgroundCheckExternalLinkState {
  continueUrl?: string
  isLoading?: boolean
}

export const backgroundCheckExternalLink = (state = {}, action) => {
  switch (action.type) {
    case actions.SUBMIT_NCC_CHECK.IN_PROGRESS:
      return { ...state, isLoading: true }
    case actions.SUBMIT_NCC_CHECK.SUCCESS:
      return { ...state, ...action.payload, isLoading: false }
    case actions.SUBMIT_NCC_CHECK.FAIL:
      return { ...state, isLoading: false }
    default:
      return state
  }
}
